import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from '../services/error.service';
import { SharedService } from '../services/shared.service';
import { SessionStorage } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  @SessionStorage('region') public region;

  indiaPrimaryBusines = [
    { id: 1, primary_business: "Daily needs" },
    { id: 2, primary_business: "Grocery" },
    { id: 3, primary_business: "Repairs & Services" },
    { id: 4, primary_business: "Telecom" },
    { id: 5, primary_business: "Stationery" },
    { id: 6, primary_business: "Eat & Dine / Food" },
    { id: 7, primary_business: "Consumer goods" },
    { id: 8, primary_business: "Pharmacy" },
    { id: 9, primary_business: "Chain store" },
    { id: 10, primary_business: "Real estate" },
    { id: 11, primary_business: "Electrical, hardware and paints" },
    { id: 12, primary_business: "Apparel / fashion" },
    { id: 13, primary_business: "Others" }
  ]
  indiaLocation = [
    { id: 1, location: "Bangalore" },
    { id: 2, location: "Delhi" },
    { id: 3, location: "Mumbai" },
    { id: 4, location: "Pune" },
    { id: 5, location: "Hyderabad" },
    { id: 6, location: "Ahmedabad" },
    { id: 7, location: "Chennai" },
    { id: 8, location: "Kolkata" },
    { id: 9, location: "Noida" },
    { id: 10, location: "Jaipur" },
    { id: 11, location: "Lucknow" },
    { id: 12, location: "Visakhapatnam" },
    { id: 13, location: "Others" }
  ]

  mexicoPrimaryBusines = [
    { id: 1, primary_business: "Necesidades diarias" },
    { id: 2, primary_business: "Abarrotes" },
    { id: 3, primary_business: "Reparaciones y Servicios" },
    { id: 4, primary_business: "telecomunicaciones" },
    { id: 5, primary_business: "Papelería" },
    { id: 6, primary_business: "omer y cenar / Comida" },
    { id: 7, primary_business: "Bienes de consumo" },
    { id: 8, primary_business: "Farmacia" },
    { id: 9, primary_business: "Cadena de tiendas" },
    { id: 10, primary_business: "Bienes raíces" },
    { id: 11, primary_business: "Electricidad, ferretería y pinturas" },
    { id: 12, primary_business: "Ropa/moda" },
    { id: 13, primary_business: "Otros" }
  ]
  mexicoLocation = [
    { id: 1, location: "Mexico City" },
    { id: 2, location: "Puebla" },
    { id: 3, location: "Guadalajara" },
    { id: 4, location: "Mérida" },
    { id: 5, location: "Estado de México" },
    { id: 6, location: "León" },
    { id: 7, location: "Veracruz" },
    { id: 8, location: "Querétaro" },
    { id: 9, location: "Others" }
  ]

  egyptPrimaryBusines = [
    { id: 1, primary_business: "الاحتياجات اليومية" },
    { id: 2, primary_business: "البقالة" },
    { id: 3, primary_business: "الإصلاحات والخدمات" },
    { id: 4, primary_business: "الإتصالات" },
    { id: 5, primary_business: "مكتبة" },
    { id: 6, primary_business: "الأكل / الطعام" },
    { id: 7, primary_business: "بضائع المستهلكين" },
    { id: 8, primary_business: "مقابل" },
    { id: 9, primary_business: "سلسلة متاجر" },
    { id: 10, primary_business: "العقارات" },
    { id: 11, primary_business: "الكهرباء والأجهزة والدهانات" },
    { id: 12, primary_business: "الملابس / الموضة" },
    { id: 13, primary_business: "آخر" }
  ]

  egyptLocation = [
    { id: 1, location: "القاهرة" },
    { id: 2, location: "الإسكندرية" },
    { id: 3, location: "أخرى" }
  ]

  constructor(public httpService: HttpService, private errService: ErrorService, sharedService: SharedService
  ) {
  }
  getLead(query): Observable<any> {
    return this.httpService.get(query, 'ihsUrl').pipe(
      map((res: Response) => {
        return res.json()
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.json())
      })
    );
  }
  getReasons(query): Observable<any> {
    return this.httpService.get(query, 'ihsUrl').pipe(
      map((res: Response) => {
        return res.json()
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.json())
      })
    );
  }
  pincode(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.json());
        })
      );
  }
  filterLead(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.json());
        })
      );
  }
  getRoles(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.json());
        })
      );
  }

  rejectLead(query, data) {
    return this.httpService.put(query, data, 'ihsUrl').pipe(
      map((res: Response) => {
        return res.json()
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.json())
      })
    );
  }
  reAssignLead(query, data) {
    return this.httpService.put(query, data, 'ihsUrl').pipe(
      map((res: Response) => {
        return res.json()
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.json())
      })
    );
  }
  getZm(query, data): Observable<any> {
    return this.httpService.post(query, data).pipe(
      map((res: Response) => {
        return res.json()
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.json())
      })
    );
  }
  errorHandler(error: any) {
    this.errService.handleError(error)
  }
  getPrimaryBusiness(id) {
    let primary;
    if(this.region === 'India') {
      primary = this.indiaPrimaryBusines.find(ele => ele.id == id)
    }
    else if(this.region === 'Mexico') {
      primary = this.mexicoPrimaryBusines.find(ele => ele.id == id)
    }
    else if(this.region === 'Egypt') {
      primary = this.egyptPrimaryBusines.find(ele => ele.id == id)
    }
    return { primary_business: primary['primary_business'], id: primary['id'] };
  }
  getLocation(id) {
    let primary;
    if(this.region === 'India') {
      primary = this.indiaLocation.find(ele => ele.id == id)
    }
    else if(this.region === 'Mexico') {
      primary = this.mexicoLocation.find(ele => ele.id == id)
    }
    else if(this.region === 'Egypt') {
      primary = this.egyptLocation.find(ele => ele.id == id)
    }
    return primary['location'];
  }

}
